import React from 'react';
import { CheckCircleIcon, GiftIcon, BookOpenIcon, ArrowRightIcon, FileTextIcon, ClockIcon, SmartphoneIcon } from 'lucide-react';
import { trackAddToCart } from './MetaPixel';
const features = [{
  icon: '🍳',
  text: 'Desayunos que se hacen solos'
}, {
  icon: '🔥',
  text: 'Comidas express con alma de hogar'
}, {
  icon: '🍟',
  text: 'Recetas de airfryer con sabor LATAM'
}, {
  icon: '📦',
  text: 'Meal prep económico que libera tu semana'
}, {
  icon: '🍫',
  text: 'Postres virales de TikTok que te hacen sonreír'
}];
const bonuses = [{
  title: 'Planificador Semanal de Comidas Express',
  desc: 'Planner listo para usar. Dejo de pensar todos los días qué cocinar.',
  value: 'Bono #1',
  icon: <BookOpenIcon className="w-6 h-6" data-id="element-252" />
}, {
  title: 'Lista Inteligente de Súper LATAM',
  desc: 'Ahorra tiempo y dinero. Compro menos, gasto menos y aprovecho todo.',
  value: 'Bono #2',
  icon: <CheckCircleIcon className="w-6 h-6" data-id="element-253" />
}, {
  title: '10 Recetas Ultra Baratas de Emergencia',
  desc: 'Para días sin tiempo o dinero. Aunque esté ajustada, igual como bien.',
  value: 'Bono #3',
  icon: <GiftIcon className="w-6 h-6" data-id="element-254" />
}, {
  title: 'Postres Virales en 1 Página',
  desc: 'Guía rápida visual para el celular. Quedo bien sin complicarme.',
  value: 'Bono #4',
  icon: <GiftIcon className="w-6 h-6" data-id="element-255" />
}];
export function ProductSection() {
  const handleBuyClick = () => {
    trackAddToCart();
  };
  return <section className="py-20 bg-white" data-id="element-256">
      <div className="container mx-auto px-4" data-id="element-257">
        {/* Main Product Intro */}
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-258">
          <h2 className="text-3xl lg:text-4xl font-serif font-bold text-gray-900 mb-6" data-id="element-259">
            Todo en minutos. Todo con lo que ya tenés en casa.
          </h2>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-260">
            {features.map((feature, idx) => <div key={idx} className="bg-orange-50 px-4 py-2 rounded-full border border-orange-100 flex items-center gap-2 text-gray-700 font-medium shadow-sm hover:bg-orange-100 transition-colors" data-id="element-261">
                <span data-id="element-262">{feature.icon}</span>
                <span data-id="element-263">{feature.text}</span>
              </div>)}
          </div>
        </div>

        {/* Product Details Block */}
        <div className="max-w-4xl mx-auto bg-gray-50 rounded-2xl p-8 mb-16 border border-gray-100" data-id="element-264">
          <h3 className="text-xl font-bold text-gray-900 mb-6 text-center" data-id="element-265">
            ¿Qué recibís exactamente?
          </h3>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-266">
            <div className="flex gap-3" data-id="element-267">
              <div className="bg-white p-2 rounded-lg shadow-sm text-rose-500 h-fit" data-id="element-268">
                <FileTextIcon className="w-5 h-5" data-id="element-269" />
              </div>
              <div data-id="element-270">
                <h4 className="font-bold text-gray-800" data-id="element-271">
                  Formato PDF Descargable
                </h4>
                <p className="text-sm text-gray-600" data-id="element-272">
                  Acceso inmediato. Tuyo para siempre.
                </p>
              </div>
            </div>
            <div className="flex gap-3" data-id="element-273">
              <div className="bg-white p-2 rounded-lg shadow-sm text-rose-500 h-fit" data-id="element-274">
                <BookOpenIcon className="w-5 h-5" data-id="element-275" />
              </div>
              <div data-id="element-276">
                <h4 className="font-bold text-gray-800" data-id="element-277">
                  50 Recetas Organizadas
                </h4>
                <p className="text-sm text-gray-600" data-id="element-278">
                  Categorizadas por situación (cansancio, ahorro, tiempo).
                </p>
              </div>
            </div>
            <div className="flex gap-3" data-id="element-279">
              <div className="bg-white p-2 rounded-lg shadow-sm text-rose-500 h-fit" data-id="element-280">
                <ClockIcon className="w-5 h-5" data-id="element-281" />
              </div>
              <div data-id="element-282">
                <h4 className="font-bold text-gray-800" data-id="element-283">Tiempo Real</h4>
                <p className="text-sm text-gray-600" data-id="element-284">
                  5-10 minutos de preparación activa.
                </p>
              </div>
            </div>
            <div className="flex gap-3" data-id="element-285">
              <div className="bg-white p-2 rounded-lg shadow-sm text-rose-500 h-fit" data-id="element-286">
                <SmartphoneIcon className="w-5 h-5" data-id="element-287" />
              </div>
              <div data-id="element-288">
                <h4 className="font-bold text-gray-800" data-id="element-289">Multi-dispositivo</h4>
                <p className="text-sm text-gray-600" data-id="element-290">
                  Usalo en celular, tablet o computadora.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Product Showcase Image */}
        <div className="mb-20" data-id="element-291">
          <img src="https://cdn.magicpatterns.com/uploads/q1hR9CupyLiLaV6kS4i9JU/Diseno_sin_titulo_(1).png" alt="Colección completa de libros y bonos" className="w-full max-w-4xl mx-auto rounded-xl shadow-2xl hover:scale-[1.02] transition-transform duration-500" data-id="element-292" />
        </div>

        {/* Bonuses Grid */}
        <div className="bg-rose-50 rounded-3xl p-8 lg:p-12" data-id="element-293">
          <div className="text-center mb-12" data-id="element-294">
            <span className="bg-rose-500 text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide" data-id="element-295">
              Oferta Especial
            </span>
            <h3 className="text-3xl font-serif font-bold text-gray-900 mt-4" data-id="element-296">
              Y porque te merecés más que recetas…
            </h3>
            <p className="text-gray-600 mt-2" data-id="element-297">
              Te llevás también estos 4 BONOS OFICIALES, solo por hoy:
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-298">
            {bonuses.map((bonus, idx) => <div key={idx} className="bg-white p-6 rounded-xl shadow-sm border border-rose-100 flex gap-4 hover:shadow-md transition-shadow" data-id="element-299">
                <div className="bg-rose-100 text-rose-600 p-3 rounded-lg h-fit" data-id="element-300">
                  {bonus.icon}
                </div>
                <div data-id="element-301">
                  <div className="text-rose-500 text-xs font-bold uppercase tracking-wider mb-1" data-id="element-302">
                    {bonus.value}
                  </div>
                  <h4 className="text-lg font-bold text-gray-800 mb-2" data-id="element-303">
                    {bonus.title}
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-304">{bonus.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="text-center" data-id="element-305">
            <a href="https://pay.hotmart.com/S103786789F?checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={handleBuyClick} className="inline-flex items-center gap-2 bg-rose-500 hover:bg-rose-600 text-white text-lg px-8 py-4 rounded-full font-bold shadow-lg hover:shadow-xl transition-all animate-button-pulse" data-id="element-306">
              <span data-id="element-307">Quiero todo el pack ahora</span>
              <ArrowRightIcon className="w-5 h-5" data-id="element-308" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}